import BaoCaoDiemDanhPage from "./BaoCaoDiemDanhPage";
export default BaoCaoDiemDanhPage
